<template>
    <b-card no-body class="mb-0">
      <div class="loading_page" v-if="$store.getters['maintenances.form/isLoading']">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
      </div>
      <b-table 
        class="position-relative" 
        primary-key="id"
        :items="$store.getters['maintenances.form/historyList']" 
        :fields="$store.getters['maintenances.form/historyTableColumns']" 
        :empty-text="$t('No matching records found')"
        responsive 
        show-empty
        >

        <template #cell(details)="data">
          <b-link 
            @click="()=> $store.commit('maintenances.form/updateEventId' , {value:data.item.id})" 
            v-b-modal="'eventTableModal'"
            > 
            {{ $t('MAINTENANCES_HISTORY_SHOW_LABEL') }}
          </b-link>
        </template>

      </b-table>

      <b-modal id="eventTableModal" scrollable>
              <b-table 
              class="position-relative" 
              :items="$store.getters['maintenances.form/event']['attributes']"
              :fields="$store.getters['maintenances.form/eventTableColumns']"
              :empty-text="$t('No matching records found')"
              show-empty
              responsive
              />

              <template #modal-footer="{cancel}">
                <b-button @click="cancel()">
                  {{ $t('MAINTENANCES_HISTORY_CLOSE_LABEL') }}
                </b-button>
              </template>

            </b-modal>
    </b-card>
</template>

<script>

import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BModal,
  VBModal
} from 'bootstrap-vue'

import vSelect from 'vue-select'

import { OrbitSpinner } from 'epic-spinners'


import Ripple from 'vue-ripple-directive'

export default {
  components: {
    OrbitSpinner,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  props:{
    logs:{
      type:Array
    }
  },
  setup( props, { root } ) {

    return {}
  }
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
.table > tbody > tr > td {
max-width:150px !important;

}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.actionIcon>button {
  padding: 0;
}
.table > tbody > tr > td {
max-width:200px;

}


</style>
